import { render, staticRenderFns } from "./Rating_Disparity.vue?vue&type=template&id=2fa828ca&scoped=true"
import script from "./Rating_Disparity.vue?vue&type=script&lang=js"
export * from "./Rating_Disparity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa828ca",
  null
  
)

export default component.exports